export type TDashboardListParams = {
  page: number;
  pageSize: number;
};

export const adminDashboardKeys = {
  all: [{ module: 'adminDashboard' }] as const,
  info: () => [{ ...adminDashboardKeys.all[0], scope: 'info' }] as const,
  submissionSummary: () => [{ ...adminDashboardKeys.all[0], scope: 'submissionSummary' }] as const,
  eventDurations: () => [{ ...adminDashboardKeys.all[0], scope: 'eventDurations' }] as const,
  attemptLists: () => [{ ...adminDashboardKeys.all[0], scope: 'attemptList' }] as const,
  attemptList: (params: TDashboardListParams) => [{ ...adminDashboardKeys.attemptLists()[0], params }] as const,
  erroredJobLists: () => [{ ...adminDashboardKeys.all[0], scope: 'erroredJobList' }] as const,
  erroredJobList: (params: TDashboardListParams) => [{ ...adminDashboardKeys.erroredJobLists()[0], params }] as const,
  processingJobLists: () => [{ ...adminDashboardKeys.all[0], scope: 'processingJobList' }] as const,
  processingJobList: (params: TDashboardListParams) =>
    [{ ...adminDashboardKeys.processingJobLists()[0], params }] as const,
};
